import { trackRetailerMobileSidebarAccountDropdownClick } from "@faire/web-api/events/retailerMobile/click/sidebarAccountDropdown";
import { getDocumentOrThrow } from "@faire/web/common/globals/getDocument";
import { makeObservable } from "@faire/web/common/makeObservable";
import { action, computed, observable, reaction } from "mobx";

import { topNavEvent } from "./Events";

class HeaderState {
  @observable
  isShowingMenu = false;
  @observable
  isShowingMobileSearch = false;
  @observable
  isShowingAccountMenu = false;
  @observable
  private isSearchVisible = false;
  @observable
  private query: string = "";

  constructor() {
    makeObservable(this);
    // create a hook into search state that will close mobile search
    // when search field loses focus
    reaction(
      () => this.isSearchVisible,
      (visible: boolean) => {
        if (!visible) {
          this.hideMobileSearch();
        }
      }
    );
  }

  @computed
  get searchQuery() {
    return this.query;
  }

  @computed
  get searchVisible() {
    return this.isSearchVisible;
  }

  @action
  showMenu = () => {
    this.isShowingMenu = true;
    getDocumentOrThrow().body.classList.add("noscroll");
  };

  @action
  hideMenu = () => {
    this.isShowingMenu = false;
    getDocumentOrThrow().body.classList.remove("noscroll");
  };

  @action
  showMobileSearch = () => {
    this.isShowingMobileSearch = true;
    this.showSearchQuery();
  };

  @action
  private hideMobileSearch = () => {
    this.isShowingMobileSearch = false;
  };

  @action
  toggleAccountMenu = () => {
    topNavEvent("account")();
    this.isShowingAccountMenu = !this.isShowingAccountMenu;
    trackRetailerMobileSidebarAccountDropdownClick();
  };

  @action
  setSearchQuery = (searchQuery: string) => {
    this.query = searchQuery;
  };

  @action
  showSearchQuery = () => {
    this.isSearchVisible = true;
  };

  @action
  hideSearchQuery = () => {
    this.isSearchVisible = false;
  };

  @action
  clearSearchQuery = () => {
    this.query = "";
  };
}

const headerState = new HeaderState();
export default headerState;
